import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSsoRequest } from '../../selectors';
import { getRedirectUrl } from '../../actions';
import { selectInstitution } from '../../../../store/features/system';
import './SsoAutoLogin.scss';
export const SsoAutoLogin = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const ssoRequest = useSelector(selectSsoRequest);
    const defaultError = 'Hmm... Something went wrong. Please try again.';
    const institution = useSelector(selectInstitution);
    const institutionId = institution?.id;
    useEffect(() => {
        if (!ssoRequest?.sso) {
            setError(defaultError);
            return;
        }
        const fetchData = async () => {
            try {
                setIsLoading(true);
                window.location.href = await getRedirectUrl({
                    institutionId,
                    ...ssoRequest,
                });
            }
            catch (err) {
                setIsLoading(false);
                setError(err.data?.error?.message ?? err.message ?? defaultError);
            }
        };
        void fetchData();
    }, [institutionId, ssoRequest]);
    return (<div className="sso-auto-login">
      {isLoading ? (<div className="sso-auto-login__loader root-page-loader">
          <svg viewBox="25 25 50 50">
            <circle cx="50" cy="50" r="21" fill="none" strokeWidth="2" strokeMiterlimit="10"></circle>
          </svg>
        </div>) : (error && <div className="sso-auto-login__error">{error}</div>)}
    </div>);
};
